import React from "react"

import ImageGalleryItem from "./ImageGalleryItem"

export default ({ images, galleryTitle }) => {
  if (!images) {
    return null
  }

  return (
    <div>
      {images.map((item, i) => (
        <ImageGalleryItem
          key={item.id || i}
          item={item}
          index={i}
          fallbackAlt={galleryTitle && `${galleryTitle}, photo ${i + 1}`}
        />
      ))}
    </div>
  )
}
